import type { MagentoSelectedShippingMethod, MagentoShippingMethod } from "@jti/magento-types";

import type { DeliveryOptionsFieldConfig } from "@checkout-v2/formFields/components/DeliveryOptionsField/DeliveryOptionsField.types";
import type { FormFieldFactory } from "@checkout-v2/formFields/types/FormFieldFactory.types";

type FactoryInput = {
  options: MagentoShippingMethod[];
  selectedOption: MagentoSelectedShippingMethod | null | undefined;
  cartId?: string;
  onChange?: (value: string) => void;
  isLoading?: boolean;
  __: (key: string) => string;
};

export type DeliveryOptionsFactoryDerivedConfig = Omit<DeliveryOptionsFieldConfig, "selectionDisabled">;

export const deliveryOptionsFactory: FormFieldFactory<
  "deliveryOption",
  string | undefined,
  [FactoryInput],
  [FactoryInput],
  DeliveryOptionsFactoryDerivedConfig
> = {
  getDerivedConfig: ({ options = [], cartId, onChange, isLoading = false, __ }) => {
    return {
      name: "deliveryOption",
      isLoading,
      isHidden: options.length === 0 && !isLoading,
      options,
      isSubscription: false,
      cartId,
      onChange,
      registerOptions: {
        required: __("cart.checkout.shipping_options.validation.required"),
      },
    };
  },
  getDefaultValue: (input) => {
    const { selectedOption } = input;
    return selectedOption?.methodCode;
  },
};
